<template>
  <v-col
    cols="12"
    md="6"
  >
    <v-card class="account-details mb-8">
      <v-card-title>
        Summary Details
        <v-chip
          class="ma-2"
          color="pink lighten-1"
          label
          small
          text-color="white"
        >
          <v-icon left>
            mdi-pound
          </v-icon>
          {{ name }}
        </v-chip>
      </v-card-title>
      <ul class="report-details-list report-details-list__text-left">
        <li
          v-for="(item, index) in safeGuardingWalletsSummariesFields"
          :key="index"
          class="report-details-list__item"
        >
          <b>{{ item.text }}</b>
          {{ data[item.value] }}
        </li>
      </ul>
      <v-card-actions>
        <v-btn
          color="orange lighten-2"
          text
          @click="showWalletsDetails = !showWalletsDetails"
        >
          {{
            showWalletsDetails ? "Hide Wallet Groups" : "Show Wallet Groups"
          }}
        </v-btn>
        <v-spacer />
        <v-btn
          icon
          @click="showWalletsDetails = !showWalletsDetails"
        >
          <v-icon>
            {{ showWalletsDetails ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>
        </v-btn>
      </v-card-actions>
      <v-expand-transition>
        <div v-show="showWalletsDetails">
          <v-divider />
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Currency
                    </th>
                    <th class="text-left">
                      Rate
                    </th>
                    <th class="text-left">
                      Total Wallets Balance
                    </th>
                    <th class="text-left">
                      Total Wallets Balance GBP
                    </th>
                    <th class="text-left">
                      Wallets Amount
                    </th>
                    <th class="text-left">
                      Bank Currency
                    </th>
                    <th class="text-left">
                      Total Wallets Balance In Bank Currency
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in data.walletGroups"
                    :key="item.currency"
                  >
                    <td>{{ item.currency }}</td>
                    <td>{{ item.rate }}</td>
                    <td>{{ item.totalWalletsBalance }}</td>
                    <td>{{ item.totalWalletsBalanceGbp }}</td>
                    <td>{{ item.walletsAmount }}</td>
                    <td>{{ item.bankCurrency }}</td>
                    <td>{{ item.totalWalletsBalanceInBankCurrency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </v-col>
</template>

<script>
import {safeGuardingWalletsSummariesFields} from "@/utils/staticTablesColumns";

export default {
  name: 'CardWalletsSummaryDetail',
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showWalletsDetails: false
    }
  },
  created() {
    this.safeGuardingWalletsSummariesFields = safeGuardingWalletsSummariesFields;
  }
}
</script>
